import { Theme } from '@chakra-ui/react'

export interface NucbaConfigTheme extends Partial<Theme['config']> {}

export const config: NucbaConfigTheme = {
  initialColorMode: 'dark',
}
